import React from "react";
import PropTypes from "prop-types";
import { Link } from "gatsby";
import parse from "html-react-parser";

import "./pageListItem.scss";
import { arrowNavigationRight } from "../../assets/images/icons";
import fallbackIcon from "../../assets/images/fallback_icon.png";

const PageListItem = ({
  allPagesData = {},
  uri = "",
  showIcon = false,
}) => {
  const { title = "", thumbnailUrl = "" } =
    allPagesData[uri] || {};

  return (
    <Link to={uri}>
      <div
        className={
          "page-list-item" + (showIcon ? " icon-grid" : "")
        }
      >
        {showIcon && thumbnailUrl &&(
          <div className="page-list-item-icon">
            <img
              src={thumbnailUrl}
            />
          </div>
        )}
        <div className="page-list-item-title">{title}</div>
        <div className="page-list-item-span">
          {parse(arrowNavigationRight)}
        </div>
      </div>
    </Link>
  );
};

PageListItem.propTypes = {
  uri: PropTypes.string,
  allPagesData: PropTypes.object,
  showIcon: PropTypes.bool,
};

export default PageListItem;
